import React from 'react'

type PlayerEventCallbacks = {
  onVideoStart: () => void
  logVideoComplete: () => void
  onVideoComplete?: () => void
  onVideoPause: (watchedTime: number) => void
}

export const attachPlayerEvents = (
  player: any,
  callbacks: PlayerEventCallbacks,
  startedOnceRef: React.RefObject<boolean>
): void => {
  if (!player) return

  let hasLogged85Percent = false

  try {
    player.off?.('play')
    player.off?.('pause')
    player.off?.('timeupdate')
    player.off?.('ended')
  } catch (error) {
    console.error('Error clearing player event listeners:', error)
  }

  player.on('play', () => {
    if (!startedOnceRef.current) {
      startedOnceRef.current = true
      callbacks.onVideoStart()
    } else {
      // Reset 85% tracking on replay
      hasLogged85Percent = false
    }
  })

  player.on('pause', () => {
    const current = player.currentTime?.() ?? 0
    const duration = player.duration?.() ?? 0
    callbacks.onVideoPause(Math.max(current, 0))
    if (duration > 0 && current >= duration - 0.01) {
      callbacks.logVideoComplete()
    }
  })

  player.on('timeupdate', () => {
    const current = player.currentTime?.() ?? 0
    const duration = player.duration?.() ?? 0
    if (duration > 0 && current / duration >= 0.85 && !hasLogged85Percent) {
      hasLogged85Percent = true
      callbacks.logVideoComplete()
    }
  })

  player.on('ended', () => {
    callbacks.logVideoComplete()
    if (callbacks.onVideoComplete) {
      callbacks.onVideoComplete()
    }
  })
}
